// @flow
import {
  SET_LICENCE_EMAIL_NOTIFICATION,
  UPDATE_LICENCE_EMAIL_NOTIFICATION,
  REMOVE_LICENCE_EMAIL_NOTIFICATION,
  CLEAR_LICENCE_EMAIL_NOTIFICATION,
  PATCH_LICENCE_EMAIL_NOTIFICATION
} from "../../global/actions/actionNames";

import Properties from "../../../Properties";

const face_root = Properties.facedb_root;
// EmailNotification type for Flow
export type EmailNotificationType = {
  uuid: string,
  licence_uuid: string,
  email_list: Array<string>,
  days: number,
  is_notified: boolean,
  created_on?: string,
  updated_on?: string
};

// UPDATE (PUT)
export const updateLicenceEmailNotification = (
  id: string,
  updatedNotification: EmailNotificationType
): * => async (dispatch: *): Promise<?EmailNotificationType> => {
  try {
    const res = await fetch(`${face_root}/api/EmailNotification/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedNotification),
      credentials: "include"
    });
    if (res.ok) {
      const data = await res.json();
      dispatch({ type: UPDATE_LICENCE_EMAIL_NOTIFICATION, payload: data });
      return data;
    } else if (res.status === 404) {
      return null; // Not found
    } else {
      throw new Error("Failed to update EmailNotification");
    }
  } catch (err) {
    // Optionally handle/log error
    throw err;
  }
};


// GET by licence

export const fetchLicenceEmailNotification = (
  licenceUuid: string
): * => async (dispatch: *): Promise<?EmailNotificationType> => {
  try {
    const res = await fetch(`${face_root}/api/EmailNotification/licence/${licenceUuid}`, { credentials: "include" });
    if (res.ok) {
      const data = await res.json();
      dispatch({ type: SET_LICENCE_EMAIL_NOTIFICATION, payload: data });
      return data;
    } else if (res.status === 404) {
      dispatch({ type: SET_LICENCE_EMAIL_NOTIFICATION, payload: null });
      return null;
    } else {
      dispatch({ type: SET_LICENCE_EMAIL_NOTIFICATION, payload: null });
      throw new Error("Failed to fetch EmailNotification");
    }
  } catch (err) {
    // Optionally handle/log error
    throw err;
  }
};

// CREATE
export const createLicenceEmailNotification = (
  notification: EmailNotificationType
): * => async (dispatch: *): Promise<?EmailNotificationType> => {
  try {
    const res = await fetch(`${face_root}/api/EmailNotification`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(notification),
      credentials: "include"
    });
    if (res.status === 201) {
      const data = await res.json();
      dispatch({ type: SET_LICENCE_EMAIL_NOTIFICATION, payload: data });
      return data;
    } else if (res.status === 409) {
      return null; // Conflict: already exists
    } else {
      throw new Error("Failed to create EmailNotification");
    }
  } catch (err) {
    // Optionally handle/log error
    throw err;
  }
};

// PATCH isNotified
export const updateIsNotified = (
  id: string,
  isNotified: boolean
): * => async (dispatch: *): Promise<?EmailNotificationType> => {
  try {
    const res = await fetch(`${face_root}/api/EmailNotification/${id}/isnotified`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(isNotified),
      credentials: "include"
    });
    if (res.ok) {
      const data = await res.json();
      dispatch({ type: PATCH_LICENCE_EMAIL_NOTIFICATION, payload: data });
      return data;
    } else if (res.status === 404) {
      return null;
    } else {
      throw new Error("Failed to update isNotified");
    }
  } catch (err) {
    // Optionally handle/log error
    throw err;
  }
};

// DELETE
export const removeLicenceEmailNotification = (id: string): * => async (dispatch: *) => {
  try {
    const res = await fetch(`${face_root}/api/EmailNotification/${id}`, { method: "DELETE", credentials: "include" });
    if (res.ok || res.status === 204) {
      dispatch({ type: REMOVE_LICENCE_EMAIL_NOTIFICATION, payload: id });
    } else if (res.status === 404) {
      // Already gone, treat as success
      dispatch({ type: REMOVE_LICENCE_EMAIL_NOTIFICATION, payload: id });
    } else {
      throw new Error("Failed to delete EmailNotification");
    }
  } catch (err) {
    // Optionally handle/log error
    throw err;
  }
};

export const clearLicenceEmailNotification = (): { type: string } => ({
  type: CLEAR_LICENCE_EMAIL_NOTIFICATION
});